import * as actions from '../../redux/actions';
import React, { Component } from 'react';
import { AboutUs1 } from '../../common/about-us/AboutUs1';
import { AboutUsIconSection } from '../../common/about-us/AboutUsIconSection';
import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import { OfficesList } from '../../common/OfficeList/OfficesList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import teupalIcon1 from '../../assets/tepual/icons/camera-about-us.svg';
import teupalIcon2 from '../../assets/tepual/icons/urban-about-us.svg';
import teupalIcon3 from '../../assets/tepual/icons/location-about-us.svg';
import singleBusImage from '../../assets/tepual/icons/single-bus-about-us.jpg';
import doubleBusImage from '../../assets/tepual/icons/double-bus-about-us.jpg';

const TepualAboutUs = ({ history }) => {
  const operator = CommonService.getLocal('op');

  const teupalIconsAndTexts = [
    { image: teupalIcon1, caption: 'Giras de estudio' },
    { image: teupalIcon2, caption: 'Transporte interurbano' },
    { image: teupalIcon3, caption: 'Viajes especiales' },
  ];

  const officeLocations = [
    {
      city: 'Salón-Cama',
      title: 'Buses Salón Cama',
      features: [
        { label: 'Capacidad de 28 a 43 pasajeros.' },
        { label: 'Televisión de 3 pantallas.' },
        { label: 'Calefacción y aire acondicionado.' },
        { label: 'Wi-Fi.' },
        { label: 'Frazadas y almohadas.' },
        { label: 'Baño.' },
        { label: 'Equipo monitoreado por GPS.' },
        { label: 'Cinturones de seguridad de 3 puntas.' },
      ],
    },
    {
      city: 'Semi-Cama',
      title: 'Buses Semi-Cama',
      features: [
        { label: 'Capacidad de 64 pasajeros.' },
        { label: 'Televisión de 3 pantallas.' },
        { label: 'Calefacción y aire acondicionado.' },
        { label: 'Baño.' },
        { label: 'Equipo monitoreado por GPS.' },
        { label: 'Cinturones de seguridad de 3 puntas.' },
      ],
    },

    {
      city: 'Buses mixtos',
      title: 'Buses mixtos',

      features: [
        { label: 'Capacidad de 56 pasajeros.' },
        { label: '12 asientos Cama, 44 Semi-Cama.' },
        { label: 'Televisión de 3 pantallas.' },
        { label: 'Calefacción y aire acondicionado.' },
        { label: 'Baño.' },
        { label: 'Equipo monitoreado por GPS.' },
        { label: 'Cinturones de seguridad de 3 puntas.' },
      ],
    },
    {
      city: 'Buses Pullman',
      title: 'Buses Pullman',
      features: [
        { label: 'Capacidad de 41 a 51 pasajeros.' },
        { label: 'Televisión de 3 pantallas.' },
        { label: 'Calefacción y aire acondicionado.' },
        { label: 'Baño.' },
        { label: 'Equipo monitoreado por GPS.' },
        { label: 'Cinturones de seguridad de 3 puntas.' },
      ],
    },
    {
      city: 'Mini buses',
      title: 'Mini buses',
      features: [
        { label: 'Capacidad para 9 pasajeros.' },
        { label: 'Asientos reclinables y paquetera.' },
        { label: 'Calefacción y aire acondicionado.' },
        { label: 'Equipo monitoreado por GPS.' },
        { label: 'Cinturones de seguridad de 3 puntas.' },
      ],
    },
    {
      city: 'Taxi buses',
      title: 'Taxi buses',
      features: [
        { label: 'Calefacción y aire acondicionado.' },
        { label: 'Equipo monitoreado por GPS.' },
        { label: 'Cinturones de seguridad.' },
      ],
    },
    {
      city: 'Vans',
      title: 'Vans',
      features: [
        { label: 'Calefacción y aire acondicionado.' },
        { label: 'Equipo monitoreado por GPS.' },
      ],
    },
  ];

  return (
    <div className="">
      <HeroSection
        title={'Nosotros'}
        height={'30vh'}
        description={'Home / Nosotros'}
        heroImage={'/theme1/about-us-main-banner.jpg'}
      />

      <div className="new-container">
        <AboutUs1
          smallHeading={'Somos pioneros en la'}
          boldHeading={'RUTA AUSTRAL Y CONO SUR'}
          aboutUsBody={operator && operator.about_us}
          imageSource={singleBusImage}
        />

        <AboutUsIconSection
          smallHeading={'Conoce'}
          boldHeading={'NUESTROS SERVICIOS'}
          iconsAndTexts={teupalIconsAndTexts}
        />

        <OfficesList
          officeLocations={officeLocations}
          image={doubleBusImage}
          operator={operator}
          smallHeading={'Descubre'}
          boldHeading={'NUESTRA FLOTA'}
        />
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TepualAboutUs);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/TepualPages/TepualAboutUs.js